import React, { FunctionComponent, useEffect, useState } from 'react'
import Label from '../../Components/Label'
import { themeColors } from '../../Components/theme';
import { connect, useDispatch } from 'react-redux';
import { url } from '../../Values/constants';
import axios from 'axios';
import { useHistory, useLocation } from "react-router-dom";
import Loading from '../../Components/Loading/Loading';
import {
    getFacebookLoginStatus,
    initFacebookSdk,
    fbLogin,
} from "../../Services/facebookSDK";
import FacebookLogin from '@greatsumini/react-facebook-login';
import { FacebookLoginClient } from '@greatsumini/react-facebook-login';
import IntegrationForm from '../../Components/Integrations/IntegrationForm';
import DynamicTable from '../../Components/DynamicTable/DynamicTable';
import { Box, Tabs, Tab, Typography } from '@material-ui/core';
import NewButton from "../../Components/NewComponents/NewButton/NewButton"
import NewConfirmationModal from '../../Components/NewComponents/NewConfirmationModal/NewConfirmationModal';
// import { fetchIntegrations, verifyGoogleSheetIntegration } from '../../Services/fbIntegration';
import IntegrationVerification from '../../Components/NewComponents/IntegrationVerification/IntegrationVerification';
import IntegrationMapFields from '../../Components/Integrations/IntegrationMapFields';
import { fetchIntegrations, deleteIntegration, updateIntegration,verifyGoogleSheetIntegration, getFBFormFields } from '../../Services/fbIntegration';
import IntegrationEditForm from '../../Components/Integrations/IntegrationEditForm';
import { googleAnalytics, googleAnalyticsCTAClick } from '../../Services/users';
import {
  setCurrentRoute
} from "../../Redux/actions";

const appId = '1124360148768951';

type props = {
    user: any;
    authToken: any;
};
const Integrations: FunctionComponent<props> = ({ user, authToken }: any) => {
    const [showIntegrationForm, setShowIntegrationForm] = useState(false);
    const [showMapIntegrationForm, setShowMapIntegrationForm] = useState(false);
    // const [showPauseIntegration, setShowPauseIntegration] = useState(false);
    const [statusChangeIntegration, setStatusChangeIntegration] = useState(false);
    const [statusChangeIntegrationType, setStatusChangeIntegrationType] = useState("INACTIVE");
    const [showDeleteIntegration, setShowDeleteIntegration] = useState(false);
    const [integrationsData, setIntegrationsData] = useState<any[]>([]);
    const [count, setCount] = useState<any>(0);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [integrationType, setIntegrationType] = useState("GOOGLE SHEET");
    const [load, setLoad] = useState(false);
    const [headers,setHeaders] = useState([])
    const [isFinished, setIsFinished] = useState(false);
    const [integrationTypeNumber, setIntegrationTypeNumber] = useState(0);
    const history = useHistory();
    const [showGiveAcess, setShowGiveAcess] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [editData, setEditData] = useState();
    const [selectedDataId, setSelectedDataId] = useState("");
    const [isGACalled, setIsGACalled] = useState<any>(false);
    const dispatcher = useDispatch();
    const handleChange = (event: any, newValue: number) => {
        setIntegrationTypeNumber(newValue);
    };
    // const headers = ['ID', 'Name', 'Type', 'Status'];
    const FBheaders = ["Integration Name", 
        "FB Page", "FB Form", 
        "Status", "Created At", "Modified At", "Created By", "Modified By"];
    const GoogleSheetheaders = [
        "Integration Name",
        // "Sheet ID", 
        "Sheet Name",
        "Status",
        "Created At",
        "Modified At",
        "Created By",
        "Modified By"
    ];
    // const data = [
    //     { ID: 1, Name: 'Integration 1', Type: 'FB LEADS', Status: 'Active' },
    //     { ID: 2, Name: 'Integration 2', Type: 'GOOGLE SHEET', Status: 'Inactive' },
    //     // Add more rows as needed
    // ];
       const [cRoute,setCRoute]=useState("") 
             const location: any = useLocation();                    
                                useEffect(() => {
                                  dispatcher(setCurrentRoute(location.pathname))
                                  setCRoute(location.pathname)
                                }, [location]);

    useEffect(() => {
        if (user.organization_id) {
            fetchIntegrations(user.organization_id, (data) => setIntegrationsData(data), authToken, setCount, pageSize, page, (val) => setLoad(val), integrationsData, isFinished, setIsFinished, integrationType, integrationTypeNumber);
        }
    }, [user, page, pageSize, integrationTypeNumber]);

    // useEffect(() => {
    //     if (
    //         integrationsData &&
    //         integrationsData.length <= (page + 1) * pageSize &&
    //         isFinished === false
    //     ) {
    //         if (page === 0) {
    //             if (authToken) {
    //                 // fetchProjectsMongo(user.organization_id, (data) => setFilterData(data), authToken, setCount, filterObject, filterSort, pageSize, page, searchQuery, (val) => setLoad(val), filterData, isFinished, setIsFinished, false, pageSize);
    //                 fetchIntegrations(user.organization_id, (data) => setIntegrationsData(data), authToken, setCount,pageSize, page,(val) => setLoad(val), integrationsData, isFinished, setIsFinished,integrationType);
    //             }
    //         } else {
    //             if (authToken) {
    //                 // fetchProjectsMongo(user.organization_id, (data) => setFilterData(data), authToken, setCount, filterObject, filterSort, pageSize, page, searchQuery, (val) => setLoad(val), filterData, isFinished, setIsFinished, true, pageSize);
    //                 fetchIntegrations(user.organization_id, (data) => setIntegrationsData(data), authToken, setCount,pageSize, page,(val) => setLoad(val), integrationsData, isFinished, setIsFinished,integrationType);
    //             }
    //         }
    //     }
    // }, [page, pageSize]);

    const verifyIntegration = (selectedId:any,sheetName:any) => {
        verifyGoogleSheetIntegration(
            user.organization_id,
            selectedId,
            sheetName,
            dispatcher,
            setLoad,
            setHeaders,
            setShowGiveAcess,
            setShowMapIntegrationForm,
            history,
            authToken,
        )

      };

    function a11yProps(index: number) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }
    useEffect(()=>{
        if(isGACalled === false){
          if(user?.uid && user?.profile){
            setIsGACalled(true)
            googleAnalytics('Integration_Screen',user)
          }
        }
      },[user])
    return (
        <Box sx={{ width: "85%", padding: 20 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
                <Box>
                    <Tabs value={integrationTypeNumber} onChange={handleChange} aria-label="integration tabs">
                        <Tab label="GOOGLE SHEET" {...a11yProps(0)} />
                        {/* {
                            (user.organization_id == "W5phvDYBAtopkrdehko2" || user.organization_id == "dAZC04j9Ex8ieHlh85eh") ? 
                            <Tab label="FB LEADS" {...a11yProps(1)} /> :
                            null
                        } */}
                        <Tab label="FB LEADS" {...a11yProps(1)} /> 
                    </Tabs>
                </Box>
                <NewButton title="Add Integration" onClick={() => { 
                    if(integrationTypeNumber === 0){
                        googleAnalyticsCTAClick("Add Google Sheet Integration","Integration Screen",user)
                    }
                    else{
                        googleAnalyticsCTAClick("Add FaceBook Sheet Integration","Integration Screen",user)
                    }
                    setShowIntegrationForm(!showIntegrationForm) 
                    }} />
            </Box>
            <DynamicTable
                headers={integrationTypeNumber === 0 ? GoogleSheetheaders : FBheaders}
                data={integrationsData}
                onEdit={(value: any) => {
                    // setShowIntegrationForm(true);

                    // editIntegration(value)
                    setEditData(value)
                    setIsEdit(true)
                    setShowIntegrationForm(true)
                }}
                onStatusChange={(value: any,integrationStatus:any) => {
                    setStatusChangeIntegration(true);
                    setSelectedDataId(value);
                    setStatusChangeIntegrationType(integrationStatus);
                }}

                onDelete={(value: any) => {
                    setShowDeleteIntegration(true);
                    setSelectedDataId(value);
                }}
                onVerify={(Id:any,value:any,sheetName:any)=>{
                    // console.log("idddddd",Id)
                    verifyIntegration(Id,sheetName)
                    setSelectedDataId(value);
                }}
                onFBVerify={(value:any)=>{
                    getFBFormFields(value,user.organization_id,setHeaders);
                    setSelectedDataId(value);
                    setShowMapIntegrationForm(true);
                }}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                count={count}
                showVerify= {true}
                integrationTypeNumber={integrationTypeNumber}
            />
            {isEdit?
            <IntegrationEditForm
                open={showIntegrationForm}
                close={() => {
                    setShowIntegrationForm(false);
                    setIsEdit(false)
                }}
                edit={isEdit}
                editData={editData}
            />:<IntegrationForm
                open={showIntegrationForm}
                close={() => {
                    setShowIntegrationForm(false);
                    window.location.reload();

                }}
            />}
            <NewConfirmationModal
                title={statusChangeIntegrationType == "INACTIVE" ? "Pause Integration" : "Resume Integration"}
                description={statusChangeIntegrationType == "INACTIVE" ? "Are you sure you want to pause this integration ?" : "Are you sure you want to resume this integration ?"}
                open={statusChangeIntegration}
                setOpen={setStatusChangeIntegration}
                onSubmit={
                    () => {
                        statusChangeIntegrationType == "INACTIVE" ?
                        updateIntegration(selectedDataId, user.organization_id, {
                            "integration_status": "INACTIVE"
                        }, dispatcher, setLoad, setStatusChangeIntegration):
                        updateIntegration(selectedDataId, user.organization_id, {
                            "integration_status": "ACTIVE"
                        }, dispatcher, setLoad, setStatusChangeIntegration);
                    }
                }
            />
            <NewConfirmationModal
                title="Delete Integration"
                description="Are you sure you want to delete this integration ?"
                open={showDeleteIntegration}
                setOpen={setShowDeleteIntegration}
                onSubmit={
                    () => {
                        deleteIntegration(selectedDataId, user.organization_id, dispatcher, setLoad, setShowDeleteIntegration);
                    }
                }
            />
            <IntegrationVerification
                title="Google Sheet Access"
                description="Please provide Access to the given Id"
                Id="readpro-gsheet@read-pro.iam.gserviceaccount.com"
                open={showGiveAcess}
                setOpen={setShowGiveAcess}
            />

            <IntegrationMapFields
                open={showMapIntegrationForm}
                close={() => {
                    setShowMapIntegrationForm(false);
                } } 
                sheetFields={headers}
                integration_name={selectedDataId}/>

        </Box>
    )
}
const mapStateToProps = (state: any) => {
    return {
        user: state.user.data,
        authToken: state.user.authToken,
    };
};
export default connect(mapStateToProps)(Integrations);

